import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import FreelancerWorkSpace from "../components/FreelancerWorkSpace.jsx";
import CreatorWorkSpace from "../components/CreatorWorkSpace";
import EntrepreneurWorkSpace from "../components/EntrepreneurWorkSpace";
import StudentWorkSpace from "../components/StudentWorkSpace";
import InfluencerWorkspace from "../components/InfluencerWorkspace";

const WorkspaceRouter = () => {
  const { user } = useAuth();
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      // Use the user role from context if available
      if (user.role || user.userRole) {
        setUserRole(user.role || user.userRole);
        setLoading(false);
      } else {
        // Check for test role in localStorage (for testing purposes)
        const testRole = localStorage.getItem("testRole");
        if (testRole) {
          setUserRole(testRole);
          setLoading(false);
          return;
        }
        // Fetch user role from backend API
        const fetchUserRole = async () => {
          try {
            const token = localStorage.getItem("token");
            if (!token) {
              setUserRole(null);
              setLoading(false);
              return;
            }
            const response = await fetch(`/api/users/${user.id}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            if (response.ok) {
              const data = await response.json();
              setUserRole(data.role || data.userRole || null);
            } else {
              setUserRole(null);
            }
          } catch (error) {
            console.error("Error fetching user role:", error);
            setUserRole(null);
          } finally {
            setLoading(false);
          }
        };
        fetchUserRole();
      }
    } else {
      setLoading(false);
    }
  }, [user]);

  if (loading) {
    return <div>Loading workspace...</div>;
  }

  if (!userRole) {
    return <Navigate to="/Test" replace />;
  }

  switch (userRole.toLowerCase()) {
    case "freelancer":
      return <FreelancerWorkSpace userId={user.id} />;
    case "student":
      return <StudentWorkSpace userId={user.id} />;
    case "content_creator":
      return <CreatorWorkSpace userId={user.id} />;
    case "influencer":
      return <InfluencerWorkspace userId={user.id} />;
    case "entrepreneur":
      return <EntrepreneurWorkSpace userId={user.id} />;
    default:
      return <Navigate to="/profile" replace />;
  }
};

export default WorkspaceRouter;
